<template lang="pug">
.info-box(
  :class="{ disabled }"
  @click="$emit('edit')"
)
  template(v-if="value")
    .row.mb-15
      .col-md-10
        i.hi.hi-16(:class="icon")
        span.name.ml-5 {{ name }}
      a.edit-icon(
        v-if="!disabled"
        href="#"
        @click.prevent="$emit('edit')"
      )
        i.hi.hi-12.hi-edit
    slot(name="when-present")
  template(v-else)
    slot(name="when-empty")
</template>

<script>
export default {
  name: 'WorkOrderDetailsInfoBox',
  props: {
    name: {
      type: String,
    },
    icon: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: null,
  },
};
</script>
